import React, { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Select } from '@/components/ui/Select';
import { Input } from '@/components/ui/Input';
import { Textarea } from '@/components/ui/Textarea';
import { useNotifications } from '@/hooks/useNotifications';
import { useAuthStore } from '@/stores/authStore';

export const NotificationTest: React.FC = () => {
  const { user } = useAuthStore();
  const { sendNotification, isSending } = useNotifications();
  const [formData, setFormData] = useState({
    type: 'INFO' as const,
    priority: 'MEDIUM' as const,
    title: '',
    message: '',
    sound: false,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.title || !formData.message) {
      return;
    }

    sendNotification({
      type: formData.type,
      priority: formData.priority,
      title: formData.title,
      message: formData.message,
      sound: formData.sound,
    });

    // Limpar formulário
    setFormData({
      type: 'INFO',
      priority: 'MEDIUM',
      title: '',
      message: '',
      sound: false,
    });
  };

  // Apenas administradores podem ver este componente
  if (user?.role !== 'ADMIN') {
    return null;
  }

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-lg">Teste de Notificações</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Tipo</label>
            <Select
              value={formData.type}
              onValueChange={(value: any) => setFormData({ ...formData, type: value })}
            >
              <option value="INFO">Informação</option>
              <option value="SUCCESS">Sucesso</option>
              <option value="WARNING">Aviso</option>
              <option value="ERROR">Erro</option>
              <option value="URGENT">Urgente</option>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Prioridade</label>
            <Select
              value={formData.priority}
              onValueChange={(value: any) => setFormData({ ...formData, priority: value })}
            >
              <option value="LOW">Baixa</option>
              <option value="MEDIUM">Média</option>
              <option value="HIGH">Alta</option>
              <option value="URGENT">Urgente</option>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Título</label>
            <Input
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              placeholder="Título da notificação"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Mensagem</label>
            <Textarea
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              placeholder="Mensagem da notificação"
              rows={3}
              required
            />
          </div>

          <div>
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={formData.sound}
                onChange={(e) => setFormData({ ...formData, sound: e.target.checked })}
                className="rounded"
              />
              <span className="text-sm">Tocar som</span>
            </label>
          </div>

          <Button
            type="submit"
            className="w-full"
            disabled={isSending || !formData.title || !formData.message}
          >
            {isSending ? 'Enviando...' : 'Enviar Notificação'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};
